import { CountKeys, Customer } from "@/interfaces/customer";

export function count(value: Customer, key: keyof CountKeys): number {
    if(value[key] && Array.isArray(value[key])) {
        return value[key].length + (value.child && value.child[key] ? value.child[key].length : 0);
    } else {
        return 0;
    }
}
